export default __webpack_public_path__ + "static/tooltip-contents-dont-light-f8fdbdf9b1ea7bafc6b1312bf0fe3b1b47e884c3100fc127a515fcdcb89aba82.png";